import { apiConstants } from "../../../utils/apiConstants";
import { apiTypes } from "../../../utils/apiTypes";
import apiRequestType from "../../apiRequestType";

const triggerNotification = (data) => {
  return apiRequestType(
    apiTypes.POST,
    apiConstants.ADMIN.ENGAGEMENT_CENTER.TRIGGER_NOTIFICATION,
    data
  );
};

export default triggerNotification;
